import AddressDef from "./AddressDef";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import CalculatedDef from "./CalculatedDef";
import ValidationDef from "./ValidationDef";
import CheckGroupDef from "./CheckGroupDef";
import ContactPageTemplateDef from "./ContactPageTemplateDef";
import ContentDef from "./ContentDef";
import ContentTemplatePageDef from "./ContentTemplatePageDef";
import DatePickerDef from "./DatePickerDef";
import DisplayIfOtherHasValueDef from "./DisplayIfOtherHasValueDef";
import DisplayElementDef from "./DisplayElementDef";
import DropDownListDef from "./DropDownListDef";
import ExtraDataShimDef from "./ExtraDataShimDef";
import FileDef from "./FileDef";
import { ForEachChildIdDef, ForEachChildIndexDef } from "./ForEachDef";
import ForEachDef from "./ForEachDef";
import FormAlternativeDef from "./FormAlternativeDef";
import FormDef from "./FormDef";
import LandingPageTemplateDef from "./LandingPageTemplateDef";
import PageDef from "./PageDef";
import StateFormDef from "./StateFormDef";
import PdfAlternativeDef from "./PdfAlternativeDef";
import RadioGroupDef from "./RadioGroupDef";
import RegionDef from "./RegionDef";
import RequireValueIfOtherHasValueDef from "./RequireValueIfOtherHasValueDef";
import SectionDef from "./SectionDef";
import TextboxDef from "./TextboxDef";
import ReceiptContentDef from "./ReceiptContentDef";
import DisplayStampedPdfDef from "./DisplayStampedPdfDef";
import DisplayGeneratedPdfDef from "./DisplayGeneratedPdfDef";
import FileDocumentDef from "./FileDocumentDef";
import CompletionRedirectDef from "./CompletionRedirectDef";
import SignatureDef from "./SignatureDef";
import CommonCheckoutDef from "./CommonCheckoutDef";
import LexmarkIntegrationDef from "./LexmarkIntegrationDef";
import CompletionEmailerDef from "./CompletionEmailerDef";
import SubmitTriggerDef from "./SubmitTriggerDef";
import WorkflowSwitchDef from "./WorkflowSwitchDef";
import CaptchaControlDef from "./CaptchaControlDef";
import CaptchaBehaviorDef, { FormCaptchaItem } from "./CaptchaBehaviorDef";
import DataTableDef, { DataTableSelectedColumnDataDef } from "./DataTableDef";
import IdVerificationDef from "./IdVerificationDef";
import { FormItem } from "@cs-ts/form-item";
import { FormDefinitionFormItem, FormDefinitionItem } from "./__DefinitionDataInterface";
import { IElementSettings } from "@cs-ts/i-element-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { AddressSettings } from "@cs-ts/address-settings";
import { FormMultiControlItem } from "@cs/FormMultiControlItem";
import { CheckGroupSettings } from "@cs-ts/check-group-settings";
import { FormJson } from "@cs-ts/form-json";
import { FormPageItem } from "@cs/FormPageItem";
import { FormFormStateItem } from "@cs/FormFormStateItem";
import { DropDownListSettings } from "@cs-ts/drop-down-list-settings";
import { ForEachSettings } from "@cs-ts/for-each-settings";
import { PageSettings } from "@cs-ts/page-settings";
import { StateFormSettings } from "@cs-ts/state-form-settings";
import { TextboxSettings } from "@cs-ts/textbox-settings";
import { ExtraDataShimSettings } from "@cs-ts/extra-data-shim-settings";
import { DataTableSettings } from "@cs-ts/data-table-settings";
import { CommonCheckoutSettings } from "@cs-ts/common-checkout-settings";
import { CompletionEmailerSettings } from "@cs-ts/completion-emailer-settings";
import { FormControlItem } from "@cs/FormControlItem";
import { CalculatedSettings } from "@cs-ts/calculated-settings";
import { ContactPageTemplateSettings } from "@cs-ts/contact-page-template-settings";
import { ContentTemplatePageSettings } from "@cs-ts/content-template-page-settings";
import { ContentSettings } from "@cs-ts/content-settings";
import { DatePickerSettings } from "@cs-ts/date-picker-settings";
import { DisplayIfOtherHasValueSettings } from "@cs-ts/display-if-other-has-value-settings";
import { LandingPageTemplateSettings } from "@cs-ts/landing-page-template-settings";
import { RadioGroupSettings } from "@cs-ts/radio-group-settings";
import { RequireValueIfOtherHasValueSettings } from "@cs-ts/require-value-if-other-has-value-settings";
import { ReceiptContentSettings } from "@cs-ts/receipt-content-settings";
import { IdVerificationSettings } from "@cs-ts/id-verification-settings";
import { FormFileItem } from "@cs/FormFileItem";

function buildElement(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<IElementSettings>, calculationContext: CalculationContext) {
    const type = definitionData.type;
    switch (type) {
        case "AddressDef":
            return new AddressDef(parentElement, elementData, definitionData as FormDefinitionItem<AddressSettings>, calculationContext);
        case "CalculatedDef":
            return new CalculatedDef(parentElement, elementData as FormMultiControlItem, definitionData as FormDefinitionItem<CalculatedSettings>, calculationContext);
        case "ValidationDef":
            return new ValidationDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CheckGroupDef":
            return new CheckGroupDef(parentElement, elementData as FormMultiControlItem, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "ContactPageTemplateDef":
            return new ContactPageTemplateDef(parentElement, elementData, definitionData as FormDefinitionItem<ContactPageTemplateSettings>, calculationContext);
        case "ContentDef":
            return new ContentDef(parentElement, elementData, definitionData as FormDefinitionItem<ContentSettings>, calculationContext);
        case "ContentTemplatePageDef":
            return new ContentTemplatePageDef(parentElement, elementData, definitionData as FormDefinitionItem<ContentTemplatePageSettings>, calculationContext);
        case "DatePickerDef":
            return new DatePickerDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<DatePickerSettings>, calculationContext);
        case "DisplayElementDef":
            return new DisplayElementDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "DisplayIfOtherHasValueDef":
            return new DisplayIfOtherHasValueDef(parentElement, elementData, definitionData as FormDefinitionItem<DisplayIfOtherHasValueSettings>, calculationContext);
        case "DropDownListDef":
            return new DropDownListDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<DropDownListSettings>, calculationContext);
        case "ExtraDataShimDef":
            return new ExtraDataShimDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<ExtraDataShimSettings>, calculationContext);
        case "FileDef":
            return new FileDef(parentElement, elementData as FormFileItem, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "ForEachChildIdDef":
            return new ForEachChildIdDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "ForEachChildIndexDef":
            return new ForEachChildIndexDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "ForEachDef":
            return new ForEachDef(parentElement, elementData, definitionData as FormDefinitionItem<ForEachSettings>, calculationContext);
        case "FormAlternativeDef":
            return new FormAlternativeDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "FormDef":
            return new FormDef(parentElement, elementData as FormJson, definitionData as FormDefinitionFormItem, calculationContext);
        case "LandingPageTemplateDef":
            return new LandingPageTemplateDef(parentElement, elementData, definitionData as FormDefinitionItem<LandingPageTemplateSettings>, calculationContext);
        case "PageDef":
            return new PageDef(parentElement, elementData as FormPageItem, definitionData as FormDefinitionItem<PageSettings>, calculationContext);
        case "StateFormDef":
            return new StateFormDef(parentElement, elementData as FormFormStateItem, definitionData as FormDefinitionItem<StateFormSettings>, calculationContext);
        case "PdfAlternativeDef":
            return new PdfAlternativeDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "RadioGroupDef":
            return new RadioGroupDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<RadioGroupSettings>, calculationContext);
        case "RegionDef":
            return new RegionDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "RequireValueIfOtherHasValueDef":
            return new RequireValueIfOtherHasValueDef(parentElement, elementData, definitionData as FormDefinitionItem<RequireValueIfOtherHasValueSettings>, calculationContext);
        case "SectionDef":
            return new SectionDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "TextboxDef":
            return new TextboxDef(parentElement, elementData as FormControlItem, definitionData as FormDefinitionItem<TextboxSettings>, calculationContext);
        case "DataTableDef":
            return new DataTableDef(parentElement, elementData, definitionData as FormDefinitionItem<DataTableSettings>, calculationContext);
        case "DataTableSelectedColumnDataDef":
            return new DataTableSelectedColumnDataDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "ReceiptContentDef":
            return new ReceiptContentDef(parentElement, elementData, definitionData as FormDefinitionItem<ReceiptContentSettings>, calculationContext);
        case "DisplayStampedPdfDef":
            return new DisplayStampedPdfDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "DisplayGeneratedPdfDef":
            return new DisplayGeneratedPdfDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "FileDocumentDef":
            return new FileDocumentDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CompletionRedirectDef":
            return new CompletionRedirectDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CommonCheckoutDef":
            return new CommonCheckoutDef(parentElement, elementData, definitionData as FormDefinitionItem<CommonCheckoutSettings>, calculationContext);
        case "SubmitTriggerDef":
            return new SubmitTriggerDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "WorkflowSwitchDef":
            return new WorkflowSwitchDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "LexmarkIntegrationDef":
            return new LexmarkIntegrationDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CompletionEmailerDef":
            return new CompletionEmailerDef(parentElement, elementData, definitionData as FormDefinitionItem<CompletionEmailerSettings>, calculationContext);
        case "SignatureDef":
            return new SignatureDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CaptchaControlDef":
            return new CaptchaControlDef(parentElement, elementData as FormCaptchaItem, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "CaptchaBehaviorDef":
            return new CaptchaBehaviorDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
        case "IdVerificationDef":
            return new IdVerificationDef(parentElement, elementData, definitionData as FormDefinitionItem<IdVerificationSettings>, calculationContext);
        default:
            //debugger;
            return new BaseElementDef(parentElement, elementData, definitionData as FormDefinitionItem<CheckGroupSettings>, calculationContext);
    }
}

export { buildElement as default };
